import React, {Component} from 'react';
import Popup from "../../../components/popup";

import { ButtonCancel, ButtonProceed, ButtonReturn } from '../../../components/buttons';

import PopupContext from '../../../context/context-popup';
import Container from '../../../layouts/containers/container';
import InputsTextarea from '../../../components/inputs/inputs-text-area';

import List from '../../../components/list';
import meetingsApi from '../../../lib/meetings/meetings-api';
import alertManager from '../../../managers/alert/alert-manager';
import LabelContainer from '../../../components/label-container';
import ErrorContainer from '../../../components/error-container';
import Cross from '../../../components/buttons/cross';

export default class PopupsCancelBooking extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {
            reason: '',
            quote: {},
            errors: {},
        };
    }

    componentDidMount() {
        meetingsApi.getBookingQuoteCancellation(this.props.booking.id, this.props.booking).then((data) => {
            console.log(data);
            this.setState({ quote: data })
        });
    }

    update() {
        const { closePopup } = this.context;

        meetingsApi.cancelMeetingRoomBooking(this.props.booking.id, {
            cancel_reason: this.state.reason,
        }, (errors) => {
            this.setState({ errors })
        }).then(() => {
            this.props.refresh();
            window.location.href = `/mydmc/bookings/${this.props.booking.id}`
        })
    }

    render() {
        const { closePopup } = this.context;
        const errors = Object.values(this.state.errors).flat();

        return (
            <Popup className="booking-cancel">
                <Popup.Content>
                    <Container.Text fontSize="30px" color="#151515">
                        Are you sure you wish to cancel Meeting booking ref:
                        <Container.Text color="#1577EA">{ this.props.booking.id }</Container.Text>
                    </Container.Text>

                    <ErrorContainer errors={errors}>
                        <List gap="20px">
                            <LabelContainer label={<Container.Text fontSize="16px" color="#929BA8">Charges Applicable</Container.Text>}>
                                <List gap="10px">
                                    <Container.Text style={{ whiteSpace: 'pre-line' }} html={`
                                        You will still be charged if you proceed with cancelling this booking.

                                        Your cancellation request is within the 72-hour window before the time of booking. 
                                        
                                        The amount charged will be: £${this.state.quote?.total} + ${this.state.quote?.credits_used} Credits
                                        
                                        Upcoming transaction information: 
                                        
                                        BACS: Your scheduled invoice will be sent via the Barnsley MBC SAP payment system and BACS payment is required. Failure to process this payment will result in further action.
                                    `}></Container.Text>
                                </List>
                            </LabelContainer>

                            <Container.Text fontSize="16px" color="#929BA8">Charges can be overridden by super admins if required.</Container.Text>

                            <InputsTextarea
                                label={<Container.Text fontSize="16px" color="#929BA8">Reason for cancellation</Container.Text>}
                                value={this.state.reason}
                                onChange={e => this.setState({ reason: e.target.value })}
                            />
                            
                            <Container.Text fontSize="16px" color="#151515">
                                Once you confirm to proceed, this booking will be cancelled and non-returnable. If payments are due and suppliers have services to provide, the MGMT team must update third-party records where applicable 
                            </Container.Text>
                        </List>
                    </ErrorContainer>
                </Popup.Content>

                <Popup.Buttons>
                    <ButtonProceed onClick={this.update.bind(this)}>Confirm Cancellation</ButtonProceed>
                    <ButtonReturn onClick={closePopup} rightIcon={<Cross/>}>Return To Booking</ButtonReturn>
                    <ButtonProceed>Contact us to discuss</ButtonProceed>
                </Popup.Buttons>
            </Popup>
        );
    }
}
